import _classCallCheck from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/createClass";
export var Reduced =
/*#__PURE__*/
function () {
  function Reduced(val) {
    _classCallCheck(this, Reduced);

    this.value = val;
  }

  _createClass(Reduced, [{
    key: "deref",
    value: function deref() {
      return this.value;
    }
  }]);

  return Reduced;
}();
export var reduced = function reduced(x) {
  return new Reduced(x);
};
export var isReduced = function isReduced(x) {
  return x instanceof Reduced;
};
export var ensureReduced = function ensureReduced(x) {
  return x instanceof Reduced ? x : new Reduced(x);
};
export var unreduced = function unreduced(x) {
  return x instanceof Reduced ? x.deref() : x;
};